import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import Navbar from "../../../components/layout/navbar";
import Icon from "../../../assets/icons";
import { showToast } from "../../../components/toast";
import { I_Profile } from "../../inventory/types";
import { RingLoader } from "react-spinners";
import { Car, Check, Compass, DollarSign, Notebook, Plane, Ratio, } from "lucide-react";
import ActionModal from "./action-modal";
import { capitalizeFirstLetter } from "../../../utilz/function";
import Table from "../../../components/table";
import FIlterSelect from "../../../components/filter-select";
import ProgressTracker from "./progressTracker";

interface OrderData {
    _id: string;
    orderId: string;
    status:string;
    source: string;
    customer: any;
    approvalStatus: string;
    paymentStatus: string;
    delivery: any;
    Items: any;
    discountAmount: number;
    totalAmount: number

    

}


const OrderDetails = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [profile, setProfile] = useState<I_Profile | null>(null);
    const [orders, setOrders] = useState<OrderData | null>(null);
    const [selectedType, setSelectedType] = useState("");

    const [modalConfig, setModalConfig] = useState<{
        isVisible: boolean;
        actionType: "approved" | "delete" | "rejected";
    }>({
        isVisible: false,
        actionType: "approved",
    })

    const columns = [
        { header: "Item", accessor: "Item" },
        { header: "Quantity", accessor: "quantity" },
        { header: "Unit Price", accessor: "unitPrice" },
        { header: "Total Price", accessor: "subTotal" },
    ];

    const column = [
        { header: "", accessor: "deliveryFee" },
        { header: "", accessor: "discount" },
        { header: "", accessor: "subtotal" },
    ];

    const userToken = localStorage.getItem("token");
    const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
        Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getOrdersById } = useRequest(
        `/orders/${id}`,
        "GET"
    );

    const { makeRequest: approveOrders, loading } = useRequest(
        `/orders/${id}/review`,
        "PUT",
        {
          Authorization: `Bearer ${userToken}`,
        }
    );

    const { makeRequest: deleteOrders } = useRequest(
        `/orders/${id}`,
        "DELETE"
    );
    const { makeRequest: UpdateOrdersStatus } = useRequest(
        `/orders/${id}/status`,
        "PUT"
    );




    useEffect(() => {
        const fetchProfile = async () => {
          const [response] = await getProfile();
          if (response.status) {
            setProfile(response.data?.user);
          }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
        const [response] = await getOrdersById();
        setOrders(response?.data?.order || null);
        };
        fetchData();
    }, []);

    const handleChangeStatus = async (selectedValue: string) => {
        setSelectedType(selectedValue)

        const [response] = await UpdateOrdersStatus({status: selectedValue})
        if (response?.status) {
            showToast(response.message, true);
            window.location.reload();
          } else {
            showToast(response?.message, false);
          }
    }  
    const handlePaymentStatus = async (selectedValue: string) => {
        setSelectedType(selectedValue)
        console.log(selectedValue)

        const [response] = await UpdateOrdersStatus({paymentStatus: selectedValue})
        if (response?.status) {
            showToast(response.message, true);
            window.location.reload();
          } else {
            showToast(response?.message, false);
          }
    }  


    const handleConfirmAction = async () => {
        if (modalConfig.actionType === "approved" || modalConfig.actionType === "rejected") {
          const [response] = await approveOrders({ approvalStatus: modalConfig.actionType });
        
          if (response?.status) {
            showToast(response.message, true);
            window.location.reload();
          } else {
            showToast(response?.message, false);
          }
        }
        else if (modalConfig.actionType === "delete") {
          const [response] = await deleteOrders();
          if (response?.status) {
            showToast(response.message, true);
            navigate(-1);
          } else {
            showToast(response?.message, false);
          }
        }
    };

    const handleApprove = () => {
        setModalConfig({
          isVisible: true,
          actionType: "approved",
        });
    };
    
    const handleDecline = () => {
        setModalConfig({
            isVisible: true,
            actionType: "rejected",
        });
    };

    const handleDelete = () => {
        setModalConfig({
            isVisible: true,
            actionType: "delete",
        });
    };

    const combinedData = orders?.Items ?
     orders.Items.map((item: { name: string | undefined; quantity: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; unitPrice: any; subTotal: any; }) => ({
         Item: (
                <div>
                  <div>{capitalizeFirstLetter(item?.name)}</div>
                </div>
              ),
              quantity: (
                <div>
                  <div>{item?.quantity}</div>
                </div>
              ),
              unitPrice: (
                <div>
                  <div>₦ {item?.unitPrice || "N/A"}</div>
                </div>
              ),
              subTotal: (
                <div>
                  <div>₦ {item?.subTotal || "N/A"}</div>
                </div>
              ),
     }))
    : []


    const combinedDatas = orders ? [
        {
            deliveryFee: (
                <div className="w-full flex justify-between items-center ">
                    <div className="font-medium text-base">Discount</div>
                    <div className="font-medium">₦{(orders?.discountAmount || 0).toLocaleString()}</div>
                </div>
            )
        },
        {
            deliveryFee: (
                <div className="w-full flex justify-between items-center ">
                    <div className="font-medium text-base">Delivery Fee</div>
                    <div className="font-medium">₦{(orders?.delivery?.deliveryFee || 0).toLocaleString()}</div>
                </div>
            )
        },
        {
            deliveryFee: (
              <div className="w-full flex justify-between items-center ">
                <div className="font-medium text-lg">Total</div>
                <div className="">₦{(orders?.totalAmount || 0).toLocaleString()}</div>
              </div>
            )
        },
    ] : [];

    <div className="bg-white rounded-3xl shadow border border-[#C9C9C9] mt-5 overflow-hidden">
        {combinedDatas.map((item, index) => (
            <div key={index}>{item.deliveryFee}</div>
        ))}
    </div>
    const steps = [
        { label: "Received", name: "received", icon: <Icon name="basket"/>},
        { label: "Processing", name: "processing", icon: <Icon name="path"/> },
        { label: "Awaiting Pickup", name: "awaitingPickup",icon: <Plane/> },
        { label: "Rider Assigned", name: "riderAssigned", icon: <Compass/> },
        { label: "Dispatched", name: "outForDelivery", icon: <Car/> },
        { label: "Delivered", name: "delivered", icon: <Check/> },
    ];


    return ( 
        <div className="min-h-screen bg-gray-50 flex flex-col">
           <Navbar profile={profile as I_Profile} />

           <main className="flex-1 container mx-auto py-6">
                <div className="flex justify-between gap-5 mt-5 mx-10">
                    <div className="flex gap-4 items-center">
                        <div
                        onClick={() => navigate(-1)}
                        className="flex gap-2 font-semibold text-[16px] border-r-2 pr-4 border-separate cursor-pointer "
                        >
                        <Icon name="appbackIcon" className="mt-1" /> Back to orders
                        </div>

                        <div>
                            <h1 className="md:text-[30px] -mt-2 font-bold">
                                {orders?.orderId}
                            </h1>

                            <div className="bg-[#FFFBEB] text-[#F59E0B] text-center capitalize" >
                                {orders?.source}
                            </div>
                        </div>
                        
                    </div>

                    <div className="text-[14px] flex gap-2 items-center">
                    {orders?.approvalStatus !== "pending" && (
    <>
        <Link
            to={`/dashboard/customers/${orders?.customer?._id}`}
            className="font-normal flex border gap-1 rounded-full p-2"
        >
            <Icon name="users" /> View customer
        </Link>
        
        {orders?.status === "processing" && (
            <button
                type="button"
                className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
                onClick={handleDelete}
            >
                <Icon name="markIcon" /> Delete
            </button>
        )}
    </>
)}

                        {orders?.approvalStatus === "pending" && (
                        <div className="flex gap-2">
                            <Link
                                to={`/customer/${orders?.customer?._id}`}
                                
                                className="font-normal flex border gap-1 rounded-full p-2"
                                
                            >
                            <Icon name="users" /> View customer
                            </Link>

                            <button
                            type="button"
                            className="font-normal flex bg-[#047401] text-[#fff] border gap-1 rounded-full p-2"
                            onClick={handleApprove}
                            >
                            <Icon name="cancelIcon" /> Approve
                            </button>

                            <button
                            type="button"
                            className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
                            onClick={handleDecline}
                            >
                            <Icon name="markIcon" /> Decline
                            </button>
                            <button
                            type="button"
                            className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
                            onClick={handleDelete}
                            >
                            <Icon name="markIcon" /> Delete
                            </button>
                        </div>
                        )}
                    </div>
                </div>

                
                <div className="grid grid-cols-3 gap-6 mt-5 mx-10 mb-20">
                    <div className="col-span-2">

                        {orders?.approvalStatus !== "pending" && orders?.approvalStatus !== "rejected" && (
                            <div className="border rounded-2xl bg-white shadow-2xl mb-5 p-5">
                                <div className="flex gap-5 items-center">
                                    <h2 className="font-bold">Order status</h2>
                                     <FIlterSelect
                                            name="status"
                                            options={[
                                                { value: "received", label: "Received" },
                                                { value: "processing", label: "Processing" },
                                                {value: "awaitingPickup", label: "Awaiting Pickup"},
                                                {value: "riderAssigned", label: "Rider Assigned"},
                                                {value: "outForDelivery", label: "Dispatched"},
                                                {value: "delivered", label: "Delivered"}
                                            ]}
                                            className="mt-2 md:mt-0  md:w-[20%]"
                                            icon="filterIcon"
                                            onChange={handleChangeStatus}
                                            value={orders?.status}
                                        />

                                </div>
                                <ProgressTracker steps={steps} currentStep={orders?.status || ""} />

                            </div>
                        )}
                        {combinedData?.length > 0 ? (
                            <div>
                                <div className="bg-white rounded-3xl shadow border border-[#C9C9C9]">
                                    <Table
                                        columns={columns}
                                        data={combinedData}
                                        selectedUserId={null}
                                    />
                                </div>

                                
                                <div className="bg-white rounded-3xl shadow border border-[#C9C9C9] mt-5">
                                <Table
                                    columns={column}
                                    data={combinedDatas}
                                    selectedUserId={null}
                                />
                                </div>
                                
                            </div>
                        
                        ) : (
                        <div className="opacity-80 mt-10 font-bold text-center mx-auto">
                            No Items found
                        </div>
                        )}
                    </div>
                    <div className="bg-white shadow border w-full border-[#C9C9C9] col-span-1">
                        <h2 className="text-lg font-semibold mb-4 px-6 py-3">
                            Customer  and Order Details
                        </h2>
                        <div className="border-t pt-4 p-6 mt-5">
                            <div className="flex flex-col gap-4">
                                <div className="flex gap-4 items-center">
                                    <div className="bg-[#E8F2E8] rounded-full p-3">
                                        <Icon name="users" />
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm mb-1">Order ID</p>
                                        <p className="font-medium capitalize">{orders?.orderId}</p>
                                    </div>
                                </div>
                                <div className="flex gap-4 items-center">
                                    <div className="bg-[#E8F2E8] rounded-full p-3">
                                        <Icon name="users" />
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm mb-1">Business Name</p>
                                        <p className="font-medium capitalize">{orders?.customer?.contactName}</p>
                                    </div>
                                </div>

                                <div className="flex gap-4 items-center">
                                    <div className="bg-[#E8F2E8] rounded-full p-3">
                                        <Ratio color="#047401" size={24}/>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm mb-1">Discount</p>
                                        <p className="font-medium capitalize">₦{orders?.discountAmount}</p>
                                    </div>
                                </div>
                                <div className="flex justify-between gap-4 items-center">
                                    <div className="flex gap-4 items-center">
                                        <div className="bg-[#E8F2E8] rounded-full p-3">
                                            <Icon name="wallet" />
                                        </div>
                                        <div>
                                            <p className="text-gray-500 text-sm mb-1">Payment Status</p>
                                            <p className="font-medium capitalize">{orders?.paymentStatus}</p>
                                        </div>
                                    </div>
                                    <FIlterSelect
                                            name="status"
                                            options={[
                                                { value: "pending", label: "Pending" },
                                                { value: "paid", label: "Paid" },
                                                { value: "unpaid", label: "Unpaid" },
                                                // {value: "awaitingPickup", label: "Awaiting Pickup"},
                                                // {value: "riderAssigned", label: "Rider Assigned"},
                                                // {value: "outForDelivery", label: "Dispatched"},
                                                // {value: "delivered", label: "Delivered"}
                                            ]}
                                            className="mt-2 md:mt-0  md:w-[50%]"
                                            icon="filterIcon"
                                            onChange={handlePaymentStatus}
                                            value={orders?.paymentStatus}
                                        />
                                    
                                </div>

                                <div className="flex gap-4 items-center">
                                    <div className="bg-[#E8F2E8] rounded-full p-3">
                                        <Car color="#047401" size={24}/>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm mb-1">Delivery Method</p>
                                        <p className="font-medium capitalize">{orders?.delivery?.deliveryMethod}</p>
                                    </div>
                                </div>
                                <div className="flex gap-4 items-center">
                                    <div className="bg-[#E8F2E8] rounded-full p-3">
                                        <DollarSign color="#047401" size={24}/>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm mb-1">Delivery Amount</p>
                                        <p className="font-medium capitalize">₦{orders?.delivery?.deliveryFee}</p>
                                    </div>
                                </div>

                                <div className="flex gap-4 items-center">
                                    <div className="bg-[#E8F2E8] rounded-full p-3">
                                        <Notebook color="#047401" size={24}/>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm mb-1">Delivery Note</p>
                                        <p className="font-medium capitalize">{orders?.delivery?.deliveryNote}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                

                {loading ? (
                    <RingLoader color="#ffffff" loading={loading} size={20} />
                    ) : (
                    <ActionModal
                        visible={modalConfig.isVisible}
                        onCancel={() => setModalConfig({ ...modalConfig, isVisible: false })}
                        onConfirm={handleConfirmAction}
                        title={
                        modalConfig.actionType === "approved"
                            ? "Approve Order"
                            : modalConfig.actionType === "rejected"
                            ? "Decline Order"
                            : "Delete Order"
                        }
                        content={`Are you sure you want to ${modalConfig.actionType} this Order?`}
                        actionType={modalConfig.actionType}
                    />
                )}

            </main>
        </div>
     );
}
 
export default OrderDetails;